import React, { Fragment, useContext, useState, useRef } from "react";
import {
  Paper,
  Button,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Moment from "moment";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    marginLeft: "1rem",
    width: "7rem",
  },
  header1: {
    zIndex: theme.zIndex.mobileStepper,
  },
}));

const DashboardStats_01_Date = () => {
  const classes = useStyles();

  const { stats_date_filter, setStatsFilter } = useContext(
    FacebookProfilesDashboardContext
  );

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (e) => {
    if (anchorRef.current && anchorRef.current.contains(e.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      setOpen(false);
    }
  };

  const handleSelect = (e) => {
    let newDate = new Date();
    let startDate, endDate;

    if (e.target.id === "Yesterday") {
      newDate.setDate(newDate.getDate() - 1);
      let date = Moment(newDate, "YYYY-MM-DD");
      date = date.format();

      startDate = date.substring(0, date.indexOf("T"));
      endDate = date.substring(0, date.indexOf("T"));
    }

    setStatsFilter("stats_date_filter", {
      startDate,
      endDate,
    });
    handleClose(e);
  };

  return (
    <Fragment>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        ref={anchorRef}
        aria-controls={open ? "stats-date-filter" : undefined}
        aria-haspopup={true}
        onClick={handleToggle}
      >
        {stats_date_filter.name} <ArrowDropDownRoundedIcon />
      </Button>
      <Popper
        transition
        role={undefined}
        anchorEl={anchorRef.current}
        open={open}
        className={classes.header1}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement,
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="stats-date-filter"
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem id="Today" onClick={handleSelect}>
                    Today{" "}
                  </MenuItem>{" "}
                  <MenuItem id="Yesterday" onClick={handleSelect}>
                    Yesterday{" "}
                  </MenuItem>{" "}
                </MenuList>{" "}
              </ClickAwayListener>{" "}
            </Paper>{" "}
          </Grow>
        )}{" "}
      </Popper>{" "}
    </Fragment>
  );
};

export default DashboardStats_01_Date;
